import React, { useState } from 'react';
import { FadeIn } from './ui/FadeIn';
import { Section } from './ui/Section';
import { ChevronDown, ChevronUp } from 'lucide-react';
interface ObjectionProps {
  question: string;
  answer: string;
}
function ObjectionItem({
  question,
  answer
}: ObjectionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-warm-border last:border-0" data-id="element-30">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full text-left py-4 flex justify-between items-center group" data-id="element-31">
        <span className="font-serif font-bold text-lg text-text-primary group-hover:text-accent-teal transition-colors" data-id="element-32">
          {question}
        </span>
        {isOpen ? <ChevronUp className="w-5 h-5 text-text-secondary" data-id="element-33" /> : <ChevronDown className="w-5 h-5 text-text-secondary" data-id="element-34" />}
      </button>
      {isOpen && <div className="pb-6 text-text-secondary leading-relaxed animate-in fade-in slide-in-from-top-2 duration-200" data-id="element-35">
          {answer}
        </div>}
    </div>;
}
export function Objections() {
  const objections = [{
    question: '“No tengo tiempo.”',
    answer: 'Por eso existe el cierre de 12 minutos. Sin eso, lo demás no se sostiene. El sistema está pensado para que no tengas que dedicarle horas, sino momentos clave.'
  }, {
    question: '“Me da ansiedad mirar.”',
    answer: 'Exacto. El sistema está hecho para que mires poco, pero mires siempre. La ansiedad baja con repetición, no con evitación. Al tener un guión, dejás de mirar el abismo y empezás a mirar tareas concretas.'
  }, {
    question: '“Yo gano poco, el problema es ese.”',
    answer: 'Puede ser. Pero el desorden te hace perder más plata (recargos, compras impulsivas, intereses, olvidos). Ordenar te devuelve margen y cabeza para pensar cómo ganar más.'
  }];
  return <Section bg="section" data-id="element-36">
      <FadeIn data-id="element-37">
        <h2 className="text-3xl font-bold mb-10 text-center" data-id="element-38">
          Objeciones típicas{' '}
          <span className="font-normal font-serif italic text-text-secondary" data-id="element-39">
            (y respuesta real)
          </span>
        </h2>

        <div className="bg-white rounded-xl border border-warm-border px-6 py-2 shadow-sm" data-id="element-40">
          {objections.map((obj, i) => <ObjectionItem key={i} {...obj} data-id="element-41" />)}
        </div>
      </FadeIn>
    </Section>;
}